<template>
	<div
		class="back-to-top-button"
		v-if="isVisible"
		@click="backToTop"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
	>
		<div
			class="arrow"
			:class="{ active: hovered === true }"
		>
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10.6617 19.6394C11.3301 19.6394 11.8749 19.0863 11.8749 18.3943L11.8749 8.07373L16.1419 12.4528C16.6131 12.9363 17.3817 12.9363 17.8617 12.4528L19.0073 11.2772C19.4784 10.7937 19.4784 10.0049 19.0073 9.51229L10.7176 1.00503C10.482 0.763259 10.1728 0.639372 9.86066 0.639372C9.55147 0.639372 9.23928 0.763259 9.0037 1.00503L0.714006 9.51229C0.242873 9.99583 0.242873 10.7846 0.714006 11.2772L1.85956 12.4528C2.33073 12.9363 3.09935 12.9363 3.57934 12.4528L7.83166 8.07373L7.83166 18.3882C7.83166 19.0742 8.37647 19.6333 9.04496 19.6333L10.6617 19.6394Z"
					fill="#434444"
				/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isVisible: false,
			hovered: false,
		};
	},

	props: {},

	computed: {},

	watch: {},
	methods: {
		initToTopButton: function () {
			$(document).bind(
				'scroll',
				function () {
					var backToTopButton = $('.back-to-top-button');
					if ($(document).scrollTop() > 300) {
						backToTopButton.addClass('show');
						this.isVisible = true;
					} else {
						backToTopButton.removeClass('show');
						this.isVisible = false;
					}
				}.bind(this)
			);
		},
		backToTop: function () {
			$('html,body').stop().animate(
				{
					scrollTop: 0,
				},
				'slow',
				'swing'
			);
		},
	},
	components: {},

	created() {},
	mounted() {
		this.$nextTick(function () {
			this.initToTopButton();
		});
	},
};
</script>

<style lang="scss">
@import '../../styles/common/variables';

.back-to-top-button {
	appearance: none;
	border: 0;
	display: grid;
	grid-template-rows: 1fr auto;
	background: $cpmec-green;
	width: auto;
	min-height: auto;
	text-align: center;
	position: fixed;
	bottom: 40px;
	right: $spacer * 2;
	opacity: 0;
	visibility: hidden;
	z-index: 90;
	padding: $spacer / 2;
	transition: 0.2s ease all;

	@media (max-width: $lg) {
		bottom: $spacer * 2;
		right: $spacer * 2;
	}

	&:hover {
		cursor: pointer;
		transform: translateY(-5px);
		box-shadow: 5px 5px rgba(#000, 0.5);
		transition: 0.2s ease all;
	}

	&.show {
		opacity: 1;
		visibility: visible;
	}

	.arrow {
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		overflow: hidden;
		width: 20px;
		height: 20px;
		transition: 0.2s ease all;

		// &.active {
		// 	height: 40px;
		// 	width: 40px;
		// 	transition: 0.2s ease all;
		// }

		svg {
			position: absolute;
			top: 0;

			path {
				fill: $cpmec-blue;
			}
		}
	}

	span {
		color: $cpmec-green !important;
		display: flex;
		justify-content: center;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/BackToTopButton.vue